import { useEffect, useState } from 'react';

const isYotpoLoaded = () => typeof window !== 'undefined' && typeof window.yotpo !== 'undefined';

/**
 * Initializes Yotpo's widget, and returns a boolean indicating whether it's loaded
 *
 * Import this hook inside any component that renders Yotpo related content
 */
const useYotpoInit = () => {
  /**
   * We need to check whether the consuming component has mounted in order to prevent
   * hydration mismatch errors, since React will expect the widget components to render
   * null during the initial hydration pass
   *
   * @see https://github.com/react/react/issues/14927#issuecomment-469878110
   */
  const [hasMounted, setHasMounted] = useState(false);

  useEffect(() => {
    let timeoutId: NodeJS.Timeout | undefined;

    if (hasMounted) {
      timeoutId = setTimeout(() => {
        try {
          if (isYotpoLoaded()) {
            window.yotpo.initWidgets();
          }
        } catch (e) {
          console.error('Encountered an issue initializing Yotpo widget', e);
        }
      });
    }

    return () => {
      if (timeoutId) {
        clearTimeout(timeoutId);
      }
    };
  }, [hasMounted]);

  useEffect(() => {
    setHasMounted(true);
  }, []);

  return isYotpoLoaded() && hasMounted;
};

export default useYotpoInit;
